import React, {Component} from 'react';
import axios from 'axios';
import {withRouter} from 'react-router-dom';
import firebase from 'utils/firebase';
import Prediction from 'components/Cards/Strategy/components/Prediction';
import {getStrategyResultsRequest} from 'requests';
import Charts from 'components/Cards/Strategy/components/Charts';
import Tags from 'components/Cards/Strategy/components/Tags';
import {Loader} from 'components/Loader';
import StrategyConfiguration from './components/StrategyConfiguration';
import MoneyBack from './components/MoneyBack';
import StrategyStats from './components/StrategyStats';
import './strategyDetails.scss';

class StrategyDetails extends Component {
  state = {
    loading: true,
    results: {},
  };

  async componentDidMount() {
    const {strategyId} = this.props.match.params;
    const userToken = await firebase.auth().currentUser.getIdToken();

    const strategyDetails = await axios({
      method: 'get',
      url: `/v3/strategies/${strategyId}`,
      headers: {
        token: userToken,
      },
    });

    const results = await getStrategyResultsRequest(strategyId);
    this.setState({strategy: strategyDetails.data, results, loading: false});
  }

  renderStrategyDetailsCard = () => {
    const {strategy, results} = this.state;

    return (
      <div className="strategy-details-card">
        <StrategyConfiguration strategy={strategy} />
        <StrategyStats strategy={strategy} results={results.results} />
      </div>
    );
  };

  renderTitle = title => <div className="strategy-title">{title || ''}</div>;

  renderDesc = desc => <div className="strategy-description">{desc || ''}</div>;

  render() {
    const {loading, strategy, results} = this.state;

    if (loading) return <Loader />;

    return (
      <div className="strategy-details-page">
        {strategy && strategy.title && this.renderTitle(strategy.title)}
        {strategy && strategy.description && this.renderDesc(strategy.description)}
        <MoneyBack moneyBack={strategy.moneyBack || 0} />
        <div className="card">
          <Prediction results={results} strategy={strategy} />
        </div>
        <div className="card">
          <Tags data={strategy.tags} />
          <Charts seasons={results.results} />
        </div>
        {!loading && this.renderStrategyDetailsCard()}
      </div>
    );
  }
}

export default withRouter(StrategyDetails);
